export function getBoardSession(token) {
  return localStorage.getItem(`board_session_${token}`);
}

export function setBoardSession(token, session) {
  localStorage.setItem(`board_session_${token}`, session);
}

export function clearBoardSession(token) {
  localStorage.removeItem(`board_session_${token}`);
}

export function boardHeaders(token) {
  const s = getBoardSession(token);
  return s ? { "X-Board-Session": s } : {};
}
